import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { Building2, ChevronDown, Check } from "lucide-react";

/**
 * Filtro multi-selezione appartamenti con checkbox (riusabile: Calendario, Portale Proprietario).
 * selected = [] significa "tutti". Passa un array di id per filtrare.
 */
export default function ApartmentCheckboxFilter({ apartments = [], selected = [], onChange, testid = "apt-checkbox-filter" }) {
  const allSelected = selected.length === 0;
  const label = allSelected
    ? "Tutti gli appartamenti"
    : selected.length === 1
      ? (apartments.find((a) => a.id === selected[0])?.name || "1 appartamento")
      : `${selected.length} appartamenti`;

  const toggle = (id) => {
    if (selected.includes(id)) onChange(selected.filter((x) => x !== id));
    else onChange([...selected, id]);
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className="h-9 min-w-44 justify-between gap-2" data-testid={`${testid}-trigger`}>
          <span className="flex items-center gap-2 truncate"><Building2 size={15} /> {label}</span>
          <ChevronDown size={15} className="shrink-0 text-slate-400" />
        </Button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 p-0" data-testid={`${testid}-content`}>
        <div className="flex items-center justify-between border-b border-slate-100 px-3 py-2">
          <span className="text-xs font-semibold text-slate-500">Appartamenti</span>
          <div className="flex gap-2">
            <button className="text-xs font-medium text-indigo-600 hover:underline" data-testid={`${testid}-all`}
              onClick={() => onChange([])}>Tutti</button>
            <button className="text-xs font-medium text-slate-400 hover:underline" data-testid={`${testid}-none`}
              onClick={() => onChange(apartments.map((a) => a.id))}>Seleziona…</button>
          </div>
        </div>
        <div className="max-h-72 overflow-y-auto p-1.5">
          <label className="flex cursor-pointer items-center gap-2 rounded-lg px-2.5 py-2 text-sm hover:bg-slate-50" data-testid={`${testid}-opt-all`}>
            <span className={`flex h-4 w-4 items-center justify-center rounded border ${allSelected ? "border-indigo-600 bg-indigo-600 text-white" : "border-slate-300"}`}>
              {allSelected && <Check size={12} />}
            </span>
            <span className="font-medium">Tutti</span>
          </label>
          {apartments.map((a) => {
            const on = selected.includes(a.id);
            return (
              <label key={a.id} className="flex cursor-pointer items-center gap-2 rounded-lg px-2.5 py-2 text-sm hover:bg-slate-50" data-testid={`${testid}-opt-${a.id}`}>
                <Checkbox checked={on} onCheckedChange={() => toggle(a.id)} />
                <span className="truncate">{a.code ? `${a.code} · ` : ""}{a.name}</span>
              </label>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}
